let CopyObject = {
  copy(obj) {
    let copy = JSON.stringify(obj);
    copy = JSON.parse(copy);
    return copy;
  },
};
export default CopyObject;
